<header class="pageHeader">
  <h3><i class="fa fa-tachometer fa-lg page-caption" aria-hidden="true"></i> {{'pageHeader.Dashboard' | translate}}</h3>
</header>

<div [@fadeInOut] class="dashboard-content">

  <!-- Feature 9 — weekly report reminder -->
  <div class="alert d-flex align-items-center justify-content-between"
       [ngClass]="reportUrgent ? 'alert-danger report-alert-flash' : 'alert-warning'"
       *ngIf="reportDue">
    <span>
      <i class="fas fa-bell mr-2"></i>
      Your weekly ICD report for <strong>{{ reportWeekEnding }}</strong> has not been submitted yet.
    </span>
    <a class="btn btn-sm" [ngClass]="reportUrgent ? 'btn-danger' : 'btn-warning'" routerLink="/hubreportupload">Submit now</a>
  </div>

  <!-- Loading spinner -->
  <div *ngIf="statsLoading" class="text-center my-5">
    <i class="fa fa-spinner fa-spin fa-2x text-muted"></i>
    <p class="text-muted mt-2">Loading dashboard data...</p>
  </div>

  <div *ngIf="!statsLoading && stats">

    <!-- KPI Cards Row (70%) + Address Change Tasks (30%) -->
    <div class="row mb-4">

      <!-- KPI Cards Container (70%) -->
      <div class="col-md-8">
        <div class="row">

          <div class="col-6 col-md-4 mb-3" *ngIf="false">
        <div class="card kpi-card border-left-primary h-100">
          <div class="card-body">
            <div class="kpi-label text-primary text-uppercase font-weight-bold small">Total ICDs</div>
            <div class="kpi-value display-5 font-weight-bold">{{ stats.totalICDs }}</div>
          </div>
          <div class="card-footer bg-transparent border-0 pt-0">
            <a routerLink="/icdreport" class="small text-primary">View all <i class="fa fa-arrow-right"></i></a>
          </div>
        </div>
      </div>

          <div class="col-6 col-md-4 mb-3">
            <div class="card kpi-card border-left-success h-100">
              <div class="card-body">
                <div class="kpi-label text-success text-uppercase font-weight-bold small">Active ICDs</div>
                <div class="kpi-value display-5 font-weight-bold text-success">{{ stats.activeICDs }}</div>
                <div class="kpi-sub text-muted small">
                  {{ stats.totalICDs > 0 ? ((stats.activeICDs / stats.totalICDs) * 100 | number:'1.0-0') : 0 }}% of total
                </div>
              </div>
              <div class="card-footer bg-transparent border-0 pt-0">
                <a routerLink="/icdreport" class="small text-success">View active <i class="fa fa-arrow-right"></i></a>
              </div>
            </div>
          </div>

          <div class="col-6 col-md-4 mb-3">
            <div class="card kpi-card border-left-warning h-100">
              <div class="card-body">
                <div class="kpi-label text-warning text-uppercase font-weight-bold small">Open Cases</div>
                <div class="kpi-value display-5 font-weight-bold text-warning">{{ stats.openCases }}</div>
                <div class="kpi-sub text-muted small">Pending review / action</div>
              </div>
              <div class="card-footer bg-transparent border-0 pt-0">
                <a routerLink="/changerequest" class="small text-warning">View cases <i class="fa fa-arrow-right"></i></a>
              </div>
            </div>
          </div>

          <div class="col-6 col-md-4 mb-3">
            <div class="card kpi-card border-left-info h-100">
              <div class="card-body">
                <div class="kpi-label text-info text-uppercase font-weight-bold small">Onboarding Pipeline</div>
                <div class="kpi-value display-5 font-weight-bold text-info">{{ stats.step2Needed + stats.step3Needed + stats.step4Needed }}</div>
                <div class="kpi-sub text-muted small">New ICDs in progress</div>
              </div>
              <div class="card-footer bg-transparent border-0 pt-0">
                <a routerLink="/icd" class="small text-info">New ICD <i class="fa fa-plus"></i></a>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Move Location Request Required -->
      <div class="col-md-4 mb-3">
        <app-sf-dashboard-address-change-tasks
          (accountNameClick)="navigateToDistributorSearch($event)">
        </app-sf-dashboard-address-change-tasks>
      </div>

    </div>

    <!-- Onboarding Trend Chart -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header bg-light d-flex justify-content-between align-items-center">
            <h6 class="mb-0"><i class="fa fa-line-chart mr-1"></i> Onboarding Trend — Case Submissions by Month</h6>
            <div class="btn-group btn-group-sm" role="group">
              <button type="button" class="btn"
                [class.btn-primary]="trendRange==='3m'" [class.btn-outline-secondary]="trendRange!=='3m'"
                (click)="setTrendRange('3m')">3M</button>
              <button type="button" class="btn"
                [class.btn-primary]="trendRange==='6m'" [class.btn-outline-secondary]="trendRange!=='6m'"
                (click)="setTrendRange('6m')">6M</button>
              <button type="button" class="btn"
                [class.btn-primary]="trendRange==='1y'" [class.btn-outline-secondary]="trendRange!=='1y'"
                (click)="setTrendRange('1y')">1Y</button>
              <button type="button" class="btn"
                [class.btn-primary]="trendRange==='2y'" [class.btn-outline-secondary]="trendRange!=='2y'"
                (click)="setTrendRange('2y')">2Y</button>
              <button type="button" class="btn"
                [class.btn-primary]="trendRange==='all'" [class.btn-outline-secondary]="trendRange!=='all'"
                (click)="setTrendRange('all')">All</button>
            </div>
          </div>
          <div class="card-body" style="height: 220px; position: relative;">
            <canvas baseChart
              [data]="trendChartData"
              [options]="trendChartOptions"
              [type]="'line'">
            </canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- Onboarding Pipeline + Recent Cases row -->
    <div class="row">

      <!-- Onboarding Pipeline -->
      <div class="col-md-4 mb-4">
        <div class="card h-100">
          <div class="card-header bg-light">
            <h6 class="mb-0"><i class="fa fa-tasks mr-1"></i> Onboarding Pipeline</h6>
          </div>
          <div class="card-body p-0">
            <ul class="list-group list-group-flush">
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span><span class="badge badge-primary badge-pill mr-2">1</span> Step 2 — ICD Info Needed</span>
                <span class="badge badge-primary badge-pill">{{ stats.step2Needed }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span><span class="badge badge-warning badge-pill mr-2">2</span> Step 3 — Hub Info Needed</span>
                <span class="badge badge-warning badge-pill">{{ stats.step3Needed }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span><span class="badge badge-info badge-pill mr-2">3</span> Step 4 — Acknowledgement</span>
                <span class="badge badge-info badge-pill">{{ stats.step4Needed }}</span>
              </li>
            </ul>
          </div>
          <div class="card-footer bg-transparent text-center">
            <a routerLink="/icd" class="btn btn-sm btn-success"><i class="fa fa-plus mr-1"></i> Add New ICD</a>
          </div>
        </div>
      </div>

      <!-- Recent Cases -->
      <div class="col-md-8 mb-4">
        <div class="card h-100">
          <div class="card-header bg-light d-flex justify-content-between align-items-center">
            <h6 class="mb-0"><i class="fa fa-clock-o mr-1"></i> Recent Cases</h6>
            <a routerLink="/changerequest" class="btn btn-sm btn-outline-secondary">View All</a>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-sm table-hover mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Case #</th>
                    <th>Account</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Next Step</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let c of stats.recentCases">
                    <td><a [routerLink]="['/icddetail/icdinfo', c.encyrptID]" class="text-primary">{{ c.caseNumber }}</a></td>
                    <td>{{ c.accountName }}</td>
                    <td><span class="text-muted small">{{ c.reason }}</span></td>
                    <td>
                      <span class="badge"
                        [class.badge-success]="c.status === 'Completed' || c.status === 'Closed'"
                        [class.badge-warning]="c.status !== 'Completed' && c.status !== 'Closed'">
                        {{ c.status }}
                      </span>
                    </td>
                    <td><span class="text-muted small">{{ c.nextStep || '—' }}</span></td>
                  </tr>
                  <tr *ngIf="stats.recentCases?.length === 0">
                    <td colspan="5" class="text-center text-muted py-3">No recent cases</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Quick Actions -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header bg-light">
            <h6 class="mb-0"><i class="fa fa-bolt mr-1"></i> Quick Actions</h6>
          </div>
          <div class="card-body d-flex flex-wrap gap-2">
            <a routerLink="/icd" class="btn btn-primary mr-2 mb-2"><i class="fa fa-plus mr-1"></i> New ICD</a>
            <a routerLink="/icdreport" class="btn btn-outline-primary mr-2 mb-2"><i class="fa fa-list mr-1"></i> View Distributors</a>
            <a routerLink="/changerequest" class="btn btn-outline-warning mr-2 mb-2"><i class="fa fa-edit mr-1"></i> Change Requests</a>
            <a routerLink="/campaignmaster" class="btn btn-outline-info mr-2 mb-2"><i class="fa fa-bullhorn mr-1"></i> Campaigns</a>
            <!--<a routerLink="/admin-query" class="btn btn-outline-secondary mb-2"><i class="fa fa-robot mr-1"></i> AI Admin Agent</a>-->
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Fallback when stats unavailable -->
  <div *ngIf="!statsLoading && !stats" class="col-12 my-5">
    <div class="card card-body bg-light text-center">
      <p class="text-muted mb-3"><i class="fa fa-exclamation-circle fa-2x"></i></p>
      <p class="text-muted">Dashboard data unavailable. Please check your connection.</p>
      <div class="d-flex flex-wrap justify-content-center gap-2">
        <a routerLink="/icdreport" class="btn btn-primary mr-2 mb-2"><i class="fa fa-list mr-1"></i> View Distributors</a>
        <a routerLink="/icd" class="btn btn-success mr-2 mb-2"><i class="fa fa-plus mr-1"></i> New ICD</a>
        <a routerLink="/admin-query" class="btn btn-outline-secondary mb-2"><i class="fa fa-robot mr-1"></i> AI Agent</a>
      </div>
    </div>
  </div>

</div>
